import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { approvedRejectedInfluencerFailure, approvedRejectedInfluencerSuccess } from '../../actions/influencerActions/approvedRejectedInfluencerActions';
import store from '../../configStore';

function* approvedRejectedInfluencer({ payload }) {
    console.log('====================================');
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.markApprovedRejectedInfluencer,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("APPROVED_REJECTED_INFLUENCER_SUCCESS status :", response.data.status);
        console.log("APPROVED_REJECTED_INFLUENCER_SUCCESS data :", response.data.response);
        console.log("APPROVED_REJECTED_INFLUENCER_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            approvedRejectedInfluencerSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("APPROVED_REJECTED_INFLUENCER_FAILURE status :", error?.response?.status);
        console.log("APPROVED_REJECTED_INFLUENCER_FAILURE data:", error?.response?.data);
        console.log("APPROVED_REJECTED_INFLUENCER_FAILURE error :", error);
        console.log('====================================');
        yield put(approvedRejectedInfluencerFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* approvedRejectedInfluencerSaga() {
    yield takeLatest(actionTypes.APPROVED_REJECTED_INFLUENCER_REQUEST, approvedRejectedInfluencer);
}

export default approvedRejectedInfluencerSaga;
